import type { TelematicsStatusDto } from "@/lib/api";
import type { KeyFobStatus, TelematicsStatus } from "@/types/telematics.types";

export function toTelematicsStatus(dto: TelematicsStatusDto): TelematicsStatus {
	return {
		batteryPercentage: dto.batteryPercentage,
		cruisingRangeKm: dto.cruisingRangeKm,
		chargingStatus: dto.chargingStatus,
		lastUpdateFromBattery: dto.lastUpdateFromBattery,
		lastUpdateFromTracking: dto.lastUpdateFromTracking,
		keyFobStatus: dto.keyFobStatus as KeyFobStatus,
		ignitionOn: dto.ignitionOn,
	};
}
